import { ChartClient } from '@frontend/chart/api';
import { IotsVolumeByStatusDonutChart } from '@frontend/chart/components';
import { Chart, ChartQueryParam } from '@frontend/chart/types';
import { IoTType } from '@frontend/iot/types';
import { useEffect, useMemo, useState } from 'react';

import { HardwareIotsVolumeByStatusDonutChartProps } from './hardware-iots-volume-by-status-donut-chart.component';

/** Fleet health excludes printers — they are not part of the monitored SPOT fleet. */
const FLEET_HEALTH_IOT_TYPES = Object.values(IoTType).filter((type) => type !== IoTType.PRINTER);

export const useHardwareIotsVolumeByStatusDonutChart = (props: HardwareIotsVolumeByStatusDonutChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        ChartClient.fetchChartData(props.accountId, IotsVolumeByStatusDonutChart.definition, {
            [ChartQueryParam.TYPE]: FLEET_HEALTH_IOT_TYPES
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    const offlineCount = useMemo(() => {
        if (!data) {
            return 0;
        }

        return data.series
            .filter((series) => series.name === 'offline')
            .flatMap((series) => series.data)
            .reduce((sum, point) => sum + point.value, 0);
    }, [data]);

    return { data, isLoading, offlineCount };
};
